export const settings = {}

const resolveFetch = () => {
  if (
    typeof globalThis !== 'undefined' &&
    typeof globalThis.fetch === 'function'
  ) {
    return globalThis.fetch.bind(globalThis)
  }
  return null
}

export const fetchSettings = () =>
  new Promise((resolve, reject) => {
    Object.assign(settings, {
      NODE_ENV: process.env.NODE_ENV,
      BUILD_NUMBER: process.env.BUILD_NUMBER
    })
    // If production try loading settings.json
    if (process.env.NODE_ENV === 'production') {
      const fetchImpl = resolveFetch()
      if (!fetchImpl) {
        reject(
          new Error('Fetch API is not available to load production settings')
        )
        return
      }
      fetchImpl(`/settings.json?v=${process.env.VUE_APP_BUILD_NUMBER}`)
        .then((res) => res.json())
        .then((data) => {
          // Merge result into config
          Object.assign(settings, data)

          resolve(settings)
        })
        .catch((err) => reject(err))
    } else {
      // use environment variables
      Object.assign(settings, {
        TENANT_PREFIX: process.env.VUE_APP_TENANT_PREFIX,
        AUTH0_DOMAIN: process.env.VUE_APP_AUTH0_DOMAIN,
        AUTH0_AUDIENCE: process.env.VUE_APP_AUTH0_AUDIENCE,
        STRIPE_PUBLIC_KEY: process.env.VUE_APP_STRIPE_PUBLIC_KEY,
        API_URL: process.env.VUE_APP_API_URL,
        ENVIRONMENT: process.env.ENVIRONMENT || 'local',
        CURRENCY: process.env.VUE_APP_CURRENCY,
        LOCALE: process.env.VUE_APP_LOCALE,
        GOOGLE_PLACE_API_KEY: process.env.VUE_APP_GOOGLE_PLACE_API_KEY,
        ACCOUNT: 'nonprod'
      })

      resolve(settings)
    }
  })
